import React, { useEffect, useState } from "react";
import { Table, Popconfirm, Space } from "antd";
import { v4 as uuidv4 } from 'uuid';
import {
  Button,
  Modal,
  TextField,
  Avatar,
  Typography,
  Box,
  Snackbar,
  Alert,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { DeleteOutlined, EditOutlined, FileAddTwoTone } from "@ant-design/icons";
import { ScheduleMessageApiService } from "../../services/api/ScheduleMessageAPIService";
import {
  API_ERROR_MESSAGE,
  API_SUCCESS_MESSAGE,
  BUTTON,
  TABLE_HEADING,
} from "../../shared/constants";

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { calculateDueDate } from "../../shared/utils";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function BabyMilestoneMemoryMessages() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTime, setSelectedTime] = useState(dayjs());
  const [snackData, setSnackData] = useState({ show: false, message: "", type: "error" });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
  });

    const [isModalOpen, setIsModalOpen] = useState(false);
      const [openModal, setOpenModal] = useState(false);

    const [form, setForm] = useState({ day: "",day_of_week:"",message_type:"",message:"",schedule_time:""});
    const [isEdit, setIsEdit] = useState(false);



  useEffect(() => {
    fetchMessageDetails();
  }, []);

  const fetchMessageDetails = () => {
    setLoading(true);
    ScheduleMessageApiService.messageListing("baby_milestone_memory")
      .then((response) => {
        setSnackData({
          show: true,
          message: response.message || API_SUCCESS_MESSAGE.LISTING_FETCH,
          type: "success",
        });

        setData(response);
      })
      .catch((errResponse) => {
        setSnackData({
          show: true,
          message:
            errResponse?.response?.data?.message ||
            API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
          type: "error",
        });
      })
      .finally(() => setLoading(false));
  };

   const handleAddNew = () => {
      setIsEdit(false);
      setForm({ day: "",day_of_week:"",message_type:"",message:"",schedule_time:""});
      setIsModalOpen(true);
    };

    const handleEdit = (record) => {
      setIsEdit(true);
      setForm({ ...record });
      setIsModalOpen(true);
    };

    const handleDelete = (record) => {
      console.log("record",record)
      ScheduleMessageApiService.messageDelete("baby_milestone_memory", record.id,record.day)
        .then(() => {
          setSnackData({
            show: true,
            message: "Deleted successfully!",
            type: "success",
          });
          fetchMessageDetails();
        })
        .catch(() =>
          setSnackData({
            show: true,
            message: "Failed to delete",
            type: "error",
          })
        );
    };

    const handleSave = () => {
        let payload ={}

        if(isEdit)
        {
          payload =
          {
            days_remaining : form.days_remaining,
            day_of_week:form.day_of_week,
            message_type:form.message_type,
            message:form.message,
            schedule_time:form.schedule_time
          }

        }
        else{
          payload =
          {
            id:uuidv4().replace(/-/g, ''),
            day: +form.day,
            day_of_week:form.day_of_week,
            message_type:form.message_type,
            message:form.message,
            schedule_time:form.schedule_time
          }
        }

        const apiCall = isEdit
          ? ScheduleMessageApiService.messageEdit("baby_milestone_memory", payload,form.id,form.day, "")
          : ScheduleMessageApiService.messageCreation("baby_milestone_memory", payload,"");

        apiCall
          .then(() => {
            setSnackData({
              show: true,
              message: isEdit ? "Updated successfully!" : "Created successfully!",
              type: "success",
            });
            fetchMessageDetails();
            setIsModalOpen(false);
          })
          .catch(() =>
            setSnackData({
              show: true,
              message: "API Error!",
              type: "error",
            })
          );
      };


  const columns = [
    {
      title: TABLE_HEADING.DAY_OF_PREGNANCY,
      dataIndex: 'day',
      width:"7%",
    },
    {
      title: TABLE_HEADING.DAY,
      dataIndex: 'day_of_week',
      width:"10%",
    },
      {
        title: "Due Date By",
        dataIndex: "due_date",
        width: "10%",
        render: (_, record) => calculateDueDate(record.day),
      },
      {
        title: TABLE_HEADING.TYPE_OF_MESSAGE,
        dataIndex: 'message_type',
        width:"10%",
      },
      {
        title: TABLE_HEADING.MESSAGE,
        dataIndex: 'message',
        width:"20%",
      },
      {
        title: TABLE_HEADING.SCHEDULE_TIME,
        dataIndex: 'schedule_time',
        width:"7%",
        render: (schedule_time) => {
          const utcDateTime = dayjs.utc(`${dayjs().format('YYYY-MM-DD')}T${schedule_time}`);
          const cstTime = utcDateTime.tz("America/Chicago").format("hh:mm A [CST]");
          return cstTime;
        },
      },
    {
      title: TABLE_HEADING.ACTION,
      key: "action",
      width:"5%",
      render: (record) => (
        <Space>
                 <Button onClick={() => handleEdit(record)} startIcon={<EditOutlined />}>
                   {BUTTON.EDIT}
                 </Button>
                 <Popconfirm
                   title="Are you sure to delete this message?"
                   onConfirm={() => handleDelete(record)}
                   okText="Yes"
                   cancelText="No"
                 >
                   <Button startIcon={<DeleteOutlined style={{color:"red"}}/>}> </Button>
                 </Popconfirm>
               </Space>
      ),
    },
  ];

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="space-between" p={2}>
              <Box display="flex" alignItems="center" gap={2}>
                <Avatar sx={{ bgcolor: "blue", width: 48, height: 48, fontSize: 20 }}>BM</Avatar>
                <Typography variant="h6" fontWeight="bold">
                Baby Milestone & Memory <Typography component="span">– Messages</Typography>
                </Typography>
              </Box>
              <Button
                variant="contained"
                color="primary"
                startIcon={<FileAddTwoTone />}
                onClick={handleAddNew}
              >
                Add New
              </Button>
            </Box>

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
          <CircularProgress />
        </Box>
      ) : (
        <Table
        className="custom-table"
        columns={columns}
        dataSource={data}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '200'],
          onChange: (page, pageSize) => {
            setPagination({ current: page, pageSize });
            window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top on page change
          },
        }}
      />
      )}

      <Dialog
                    open={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    maxWidth="md"
                    fullWidth
                  >
           <DialogTitle>{isEdit? "Update": "Add new" }</DialogTitle>
           <DialogContent>
              <Box display="flex" flexDirection="column" gap={2} p={2}>
                <TextField
                  label="Day of Pregnancy"
                  value={form.day}
                  onChange={(e) => setForm({ ...form, day: e.target.value })}
                  type="number"
                  fullWidth
                />
                <TextField
                  label="Day"
                  value={form.day_of_week}
                  onChange={(e) => setForm({ ...form, day_of_week: e.target.value })}
                  type="text"
                  fullWidth
                />

                <FormControl >
                  <InputLabel id="demo-simple-select-helper-label">Type of Message</InputLabel>
                  <Select
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    value={form.message_type}
                    label="Type of message"
                    onChange={(e) => setForm({ ...form, message_type: e.target.value })}
                  >
                    <MenuItem value={"Memory"}>Memory</MenuItem>
                    <MenuItem value={"Non Memory"}>Non Memory</MenuItem>
                  </Select>

                </FormControl>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    label="Schedule Time (UTC)"
                    value={
                      form.schedule_time
                        ? dayjs
                            .utc(`${dayjs().format("YYYY-MM-DD")}T${form.schedule_time}`)
                        : null
                    }
                    onChange={(newValue) => {
                      if (newValue) {
                        const timeOnly = newValue.format("HH:mm:ss"); // e.g., "14:30:00"
                        setSelectedTime(newValue);
                        setForm({ ...form, schedule_time: timeOnly });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        helperText="Time is stored and shown in UTC"
                      />
                    )}
                    
                  />
                </LocalizationProvider>

                <TextField
                  label="Message"
                  value={form.message}
                  multiline
                  minRows={4}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  fullWidth
                />
                </Box>
                </DialogContent>
                <DialogActions>
                <Box display="flex" justifyContent="flex-end" mt={2} gap={2}>
                  <Button variant="outlined" onClick={() => setIsModalOpen(false)}>
                    Cancel
                  </Button>
                  <Button variant="contained" color="primary" onClick={handleSave}>
                    {isEdit ? "Update" : "Create"}
                  </Button>
                </Box>
                </DialogActions>

                  </Dialog>

      <Snackbar
        style={{ top: "80px" }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackData.show}
        autoHideDuration={3000}
        onClose={() => setSnackData({ show: false })}
      >
        <Alert
          onClose={() => setSnackData({ show: false })}
          severity={snackData.type}
        >
          {snackData.message}
        </Alert>
      </Snackbar>
    </>
  );
}
